import React from "react";
import Headers from "./Headers";
import { Container, Row, Col } from "react-bootstrap";
import SEO from "./SEO";

export default function NotFound() {
  function onClick() {
    window.location.replace("https://www.glovesupboxing.ca");
  }

  return (
    <>
      <SEO title="Page Not Found | Gloves Up Boxing Gym Toronto" description="Sorry, we couldn't find that page. Head back to Gloves Up Boxing Gym in Toronto for the best classes, coaches, and memberships." />
      <div className="not-found" id="home">
        <h1 className="sr-only">Page Not Found | Gloves Up Boxing Gym Toronto</h1>
        <p className="sr-only">
          Page not found. The Gloves Up Boxing page you're looking for doesn’t exist. Please return to the homepage for boxing classes, memberships, or gym information in Toronto.
        </p>
        <Headers title="Page Not Found" />
        <div className="not-found-body">
          <Container>
            <Row className="not-found-msg">
              <Col className="d-flex justify-content-center">
                Sorry this page does not exist <br /> please return home using the
                button below<br /> Thank you!
              </Col>
            </Row>
            <Row>
              <Col xs={1}></Col>
              <Col className="d-flex justify-content-center">
                <a className="btn btn-secondary" alt="Home Page Button" onClick={() => onClick()}>Go to Homepage</a>
              </Col>
              <Col xs={1}></Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}
